import React, { useState } from 'react';
import { getUserInfo } from '@/models/User';
import { login } from '@/lib';
import style from './Style.module.scss';
import ModalRule from '@/components/ModalRule';
import ModalHistory from '@/components/ModalHistory';
import ModalRegister from '@/components/ModalRegister';
import ModalVerifyStudent from '@/components/ModalVerifyStudent';
import ModalVerifyQr from '@/components/ModalVerifyQr';


const Header: React.FC = () => {
	const userData = getUserInfo();

	const [modalRule, setModalRule] = useState(false);
	const [modalHistory, setModalHistory] = useState(false);
	const [modalRegister, setModalRegister] = useState(false);
	const [modalVerifyStudent, setModalVerifyStudent] = useState(false);
	const [modalVerifyQr, setModalVerifyQr] = useState(false);

	const closeModalRegister = (status: boolean = false) => {

		setModalRegister(false);
		if (status) {
			setModalVerifyStudent(true);
		}
	}

	const scrollTo = (e: React.SyntheticEvent, ele: string) => {
		e.preventDefault();
		let section = document.getElementById(ele);
		if (section) {
			section.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	};

	return (
		<>
			<header className={`${style['header']}`}>
				<div className={`${style['header__wrap']}`}>
					<div className={`${style['header__logo']}`}>
						<img src="/images/logo.png" alt="" />
					</div>
					<div className={`${style['header__right']}`}>
						<div className={`${style['header__menu']}`}>
							<a
								href="#"
								className={`${style['header__menu__link']}`}
								onClick={(e) => {
									e.preventDefault();
									setModalRule(true);
								}}
							>
								Hướng dẫn
							</a>
							<a
								href="#"
								className={`${style['header__menu__link']}`}
								onClick={(e) => {
									e.preventDefault();
									scrollTo(e, 'section7');
								}}
							>
								Nhiệm vụ
							</a>
							<a
								href="#"
								className={`${style['header__menu__link']}`}
								onClick={(e) => {
									e.preventDefault();
									scrollTo(e, 'section4');

								}}
							>
								Dream team
							</a>
							{/* <a
								href="#"
								className={`${style['header__menu__link']}`}
								onClick={(e) => {
									e.preventDefault();
									scrollTo(e, 'section5');

								}}
							>
								Shop
							</a> */}
							<a
								href="#"
								className={`${style['header__menu__link']}`}
								onClick={(e) => {
									e.preventDefault();
									if (!userData?.payload?.user?.id) {
										window.location.href = '/user/login';
										return;
									}
									setModalHistory(true);
								}}
							>
								Lịch sử
							</a>
							<a
								href="#"
								className={`${style['header__menu__link']}`}
								onClick={(e) => {
									e.preventDefault();
									scrollTo(e, 'section8');
								}}
							>
								Student cup
							</a>
							{userData?.payload?.user?.id && userData?.payload?.user?.special_permission ? (
								<a href="#" className={`${style['header__menu__icon']}`} onClick={(e) => {
									e.preventDefault();
									setModalVerifyQr(true);
								}}>
									<img src="/images/confirm-student.png" alt="" />
								</a>
							) : (
								<>
									{
										!userData?.payload?.user?.has_student_info && !userData?.payload?.user?.is_student && (
											<a href="#" className={`${style['header__studentBtn']} ${style['header__studentBtn--pending']}`} onClick={(e) => {
												e.preventDefault();
												if (!userData?.payload?.user?.id) {
													login();
													return;
												}
												setModalRegister(true);
											}}>
												<span className={`${style['header__studentBtn__label']}`}>Xác nhận sinh viên</span>
											</a>
										)}

									{userData?.payload?.user?.has_student_info && !userData?.payload?.user?.is_student && (
										<a href="#" className={`${style['header__studentBtn']} ${style['header__studentBtn--pending']}`} onClick={(e) => {
											e.preventDefault();
											if (!userData?.payload?.user?.id) {
												login();
												return;
											}
											setModalVerifyStudent(true);
										}}>
											<span className={`${style['header__studentBtn__label']}`}>Xác nhận sinh viên</span>
										</a>
									)}

									{userData?.payload?.user?.has_student_info && userData?.payload?.user?.is_student && (
										userData?.payload?.user?.student_banned && userData?.payload?.user?.student_banned > 0 ? (
											<a href="#" className={`${style['header__menu__icon']}`} onClick={(e) => e.preventDefault()}>
												<img src="/images/not-student.png" alt="" />
											</a>
										) : (
											<a href="#" className={`${style['header__studentBtn']} ${style['header__studentBtn--confirmed']}`} onClick={(e) => e.preventDefault()}>
												<span className={`${style['header__studentBtn__icon']}`}></span>
												<span className={`${style['header__studentBtn__label']}`}>Đã xác nhận<br />sinh viên</span>
												<span className={`${style['header__studentBtn__tick']}`}></span>
											</a>
										)
									)}
								</>
							)}
						</div>
						{userData?.payload?.user?.id && (
							<div className={`${style["header__info"]}`}>
								<span className={`${style["header__info__iconAvatar"]}`}></span>HI<span className="nickname">{userData?.payload?.user?.nickname}</span>
							</div>
						)}
						<div className={`${style['header__btn']}`}>
							{userData?.payload?.user?.id ? (
								<a
									href="/user/logout"
									className={`${style["header__btn__link"]}`}
								>
									<span>Đăng xuất</span>
									{/* <img src="/images/icon-logout.png" alt="" /> */}
								</a>
							) : (
								<a
									href="/user/login"
									className={`${style["header__btn__link"]}`}
								>
									<span>Đăng nhập</span>
									{/* <img src="/images/icon-login.png" alt="" /> */}
								</a>
							)
							}
						</div>
					</div>
					{/* {userData?.payload?.user?.id ? (
						<a href="/user/logout" className={`${style['header__icon']}`}>
							<img src="/images/icon-logout.png" alt="" />
						</a>
					) : (
						<a href="/user/login" className={`${style['header__icon']}`}>
							<img src="/images/icon-login.png" alt="" />
						</a>
					)} */}
				</div>
			</header>
			{modalRule && <ModalRule modalStatus={modalRule} closeModal={() => setModalRule(false)} />}
			{modalHistory && <ModalHistory modalStatus={modalHistory} closeModal={() => setModalHistory(false)} />}
			{modalRegister && <ModalRegister modalStatus={modalRegister} closeModal={(status: boolean) => closeModalRegister(status)} />}
			{modalVerifyStudent && <ModalVerifyStudent modalStatus={modalVerifyStudent} closeModal={() => setModalVerifyStudent(false)} />}
			{modalVerifyQr && <ModalVerifyQr modalStatus={modalVerifyQr} closeModal={() => setModalVerifyQr(false)} />}
		</>
	);
};

export default Header;
